import * as React from 'react';
import styled from 'styled-components';
import ArrowPointer from '../atoms/ArrowPointer';

const normalizeStatus = (status: any): number | null => {
  if (status == null) return null;
  if (typeof status === 'number') return status;
  if (typeof status === 'string') {
    const n = Number(status);
    return Number.isNaN(n) ? null : n;
  }
  if (typeof status === 'object') {
    const v = (status as any).value ?? (status as any).id;
    if (v == null) return null;
    const n = Number(v);
    return Number.isNaN(n) ? null : n;
  }
  return null;
};

const ArrowPointerBlock = ({
  process,
  currentStatus,
  index,
}: Props) => {
  const statusId = normalizeStatus(currentStatus);
  const isTitleActive =
    statusId != null && process.statuses.includes(statusId);

  const subProcess = process.subProcesses.find(
    el => el.id === statusId,
  )?.title;

  return (
    <ArrowBlockWrapper
      isWide={process.subProcesses.length >= 3}
    >
      <ArrowPointer
        size="large"
        active={isTitleActive}
        index={index}
      >
        <p style={{ margin: 0 }}>{process.title}</p>
        {subProcess && (
          <p style={{ margin: 0, fontSize: 13 }}>
            {`(${subProcess})`}
          </p>
        )}
      </ArrowPointer>
    </ArrowBlockWrapper>
  );
};

const ArrowBlockWrapper = styled.div<WrapperProps>`
  // width: ${({ isWide }) => (isWide ? '30' : '23')}%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// const ArrowsSmallBlock = styled.div`
//   display: flex;
//   justify-content: center;
//   flex-wrap: wrap;
// `;

interface Props {
  process: Process;
  currentStatus: number | string | { value?: string | number; id?: number; label?: string } | null;
  index: number;
}

interface Process {
  title: string;
  subProcesses: SubProcess[];
  statuses: number[];
}

interface SubProcess {
  title: string;
  id: number;
}

interface WrapperProps {
  isWide: boolean;
}

export default ArrowPointerBlock;
